import create from "zustand";
import { logger } from "~features/seated-reservation/store/middleware";
import { IReleaseTicket } from "../nonseated-reservation.types";
import { TTrackingContext } from "~lib/helpers/googleAnalyticsTracking";

export type Ttotal = {
  totalBeforeFees: number;
  totalWithFees: number;
  totalFees: number;
  lineItemsTotal: number;
  referralDiscount: number;
};

export type Store = {
  selectedTicketTypes: {
    [eventId: string]: IReleaseTicket[];
  };
  totals: {
    [eventId: string]: Ttotal;
  };
  trackingContext: TTrackingContext;
};

const initialState: Store = {
  totals: {},
  selectedTicketTypes: {},
  trackingContext: undefined,
};

export const useNonSeatedReservationStore = create<Store>(
  logger(
    (set, get) => ({
      ...initialState,
    }),
    "non-seated-reservation-store"
  )
);

export const getState = useNonSeatedReservationStore.getState;
export const setState = useNonSeatedReservationStore.setState;

export const resetState = () => setState(initialState, true);
